// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/login_butn.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/login_butn_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/login_butn_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../statics/login_butn_active_click.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../statics/code_card_go_back.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageCard_container__92Dm8 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: 100%;
}

.PageCard_left__F\\+Tzy {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 60%;
    height: 100%;
    padding: 30px 50px;
}

.PageCard_left_header__RL\\+D0 {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
}

.PageCard_logo__o2nr4 {
    width: 34px;
    height: 41px;
}

.PageCard_logo_text__sN0gk {
    margin-left: 10px;
    font-size: 24px;
    color: #fff;
}

.PageCard_left_middle__8I0K3 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 170px;
    margin-top: 200px;
}

.PageCard_welcome__UhtTG {
    font-size: 60px;
    font-weight: bold;
    color: #fff;
}

.PageCard_explain__mbHcE {
    width: 438px;
    font-size: 24px;
    color: #fff;
    letter-spacing: 2px;
    line-height: 1.3;
}

.PageCard_right__IsFsH {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 40%;
    height: 100%;
    padding: 30px 100px;
    background-color: #fff;
}

.PageCard_right_header__9K-gm {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 80px;
    margin-top: 50px;
}

.PageCard_login_text__TLBSW {
    font-size: 44px;
    font-weight: bold;
    margin-bottom: 15px;
}

.PageCard_login_explain__PKaZG {
    font-size: 16px;
    color: #7e8b9e;
}

.PageCard_form__sZ1vi {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-top: 24px;
}

.PageCard_register_form__A7etO {
    padding-top: 10px;
}

.PageCard_error_info__HFXhE {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 43px;
    border-radius: 6px;
    margin-bottom: 24px;
    background-color: #fde0d0;
    color: #E31A1A;
}

.PageCard_register_error_info__450J\\+ {
    height: 30px;
    margin-bottom: 10px;
}

.PageCard_no_error_info__KOxft {
    background-color: #fff;
}

.PageCard_form_item__yt\\+Ca {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 65px;
    margin-bottom: 24px;
}

.PageCard_item_title__6swH9 {
    font-size: 14px;
    color: #323A46;
    font-weight: bold;
}

.PageCard_item_input__dKz4l {
    width: 100%;
    height: 43px;
    color: #7E8B9E;
    border-radius: 6px;
    background-color: #FAFAFC;
}

.PageCard_item_input__dKz4l:focus-within,
.PageCard_item_input__dKz4l:hover,
.PageCard_item_input__dKz4l:focus {
    border: 1px solid #17a8b5 !important;
}

.PageCard_item_input__dKz4l::placeholder {
    color: #FAFAFC;
}

.PageCard_item_input__dKz4l:-webkit-autofill {
    box-shadow: 0 0 0px 1000px #FFF inset;
}

.PageCard_remember_forget_box__cYu00 {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 65px;
    margin-bottom: 24px;
}

.PageCard_protocol_box__K7\\+qO {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 20px;
    margin-bottom: 24px;
}

.PageCard_item_remember__6uXyM,
.PageCard_item_forget__pDOKa {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 133px;
    height: 25px;
    font-size: 14px;
    color: #7E8B9E;
}

.PageCard_item_forget__pDOKa {
    justify-content: flex-end;
    color: #17a8b5;
    cursor: pointer;
}

.PageCard_submit_box__GnBAt {
    width: 100%;
    height: 43px;
}

.PageCard_submit_butn__mfIae {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    cursor: pointer;
    background-color: #abafb7;
    color: #fff;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    transition: background-image 0.5s;
}

/* 隐藏伪元素用来预加载悬停背景图 */
.PageCard_submit_butn__mfIae::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.PageCard_submit_butn_active__MzuN1 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
    transition: background 0.5s, box-shadow 0.5s;
}

/* 隐藏伪元素用来预加载悬停背景图 */
.PageCard_submit_butn_active__MzuN1::before {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.PageCard_submit_butn_active__MzuN1::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.PageCard_submit_butn_active__MzuN1:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.PageCard_submit_butn_active__MzuN1:active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.PageCard_third_login__6Z4LT {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50px;
}

.PageCard_register_box__vB1PO {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20px;
    margin: 15px 0;
}

.PageCard_register__7KXdT {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 13px;
    color: #7e8b9e;
}

.PageCard_register_link__fHtFB {
    color: #3568ff;
}

.PageCard_register_link__fHtFB:hover {
    text-decoration: underline;
}

.PageCard_right_footer__69i8s {
    position: absolute;
    left: calc(50% - 56px);
    bottom: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 112px;
    height: 75px;
}

.PageCard_footer__\\+gBY9 {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    width: 112px;
    height: 100%;
}

.PageCard_footer_img__cxjBs {
    width: 48px;
    height: 54px;
}

.PageCard_footer_text__XBvJL {
    font-size: 13px;
    color: #7E8B9E;
}

.PageCard_item_agree__Q6r0i {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 25px;
    font-size: 14px;
    color: #7E8B9E;
}

.PageCard_item_protocol__s10is {
    color: #FF8682;
}

.PageCard_code_card_main__KlP59 {
    width: 100%;
    padding-top: 200px;
}

.PageCard_code_card_header__AQO3Q {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 42px;
    height: 42px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center / 100% 100%;
    cursor: pointer;
}

.PageCard_code_card_error_info_box__JyWFm {
    padding-top: 24px;
}

.PageCard_code_card_code_box__kRSIR {
    margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/components/PageCard/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IAEI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,gFAAkF;IAClF,iCAAiC;AACrC;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,gFAAyF;IACzF,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAAyF;IACzF,4CAA4C;AAChD;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,gFAAwF;IACxF,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gFAA+F;IAC/F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAAwF;IACxF,4BAA4B;AAChC;;AAEA;IACI,gFAA+F;IAC/F,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gFAAyF;IACzF,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".container {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.left {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    width: 60%;\n    height: 100%;\n    padding: 30px 50px;\n}\n\n.left_header {\n    width: 100%;\n    height: 50px;\n    display: flex;\n    align-items: center;\n}\n\n.logo {\n    width: 34px;\n    height: 41px;\n}\n\n.logo_text {\n    margin-left: 10px;\n    font-size: 24px;\n    color: #fff;\n}\n\n.left_middle {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    height: 170px;\n    margin-top: 200px;\n}\n\n.welcome {\n    font-size: 60px;\n    font-weight: bold;\n    color: #fff;\n}\n\n.explain {\n    width: 438px;\n    font-size: 24px;\n    color: #fff;\n    letter-spacing: 2px;\n    line-height: 1.3;\n}\n\n.right {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 40%;\n    height: 100%;\n    padding: 30px 100px;\n    background-color: #fff;\n}\n\n.right_header {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 80px;\n    margin-top: 50px;\n}\n\n.login_text {\n    font-size: 44px;\n    font-weight: bold;\n    margin-bottom: 15px;\n}\n\n.login_explain {\n    font-size: 16px;\n    color: #7e8b9e;\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding-top: 24px;\n}\n\n.register_form {\n    padding-top: 10px;\n}\n\n.error_info {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 43px;\n    border-radius: 6px;\n    margin-bottom: 24px;\n    background-color: #fde0d0;\n    color: #E31A1A;\n}\n\n.register_error_info {\n    height: 30px;\n    margin-bottom: 10px;\n}\n\n.no_error_info {\n    background-color: #fff;\n}\n\n.form_item {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    height: 65px;\n    margin-bottom: 24px;\n}\n\n.item_title {\n    font-size: 14px;\n    color: #323A46;\n    font-weight: bold;\n}\n\n.item_input {\n    width: 100%;\n    height: 43px;\n    color: #7E8B9E;\n    border-radius: 6px;\n    background-color: #FAFAFC;\n}\n\n.item_input:focus-within,\n.item_input:hover,\n.item_input:focus {\n    border: 1px solid #17a8b5 !important;\n}\n\n.item_input::placeholder {\n    color: #FAFAFC;\n}\n\n.item_input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px #FFF inset;\n    box-shadow: 0 0 0px 1000px #FFF inset;\n}\n\n.remember_forget_box {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    height: 65px;\n    margin-bottom: 24px;\n}\n\n.protocol_box {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    height: 20px;\n    margin-bottom: 24px;\n}\n\n.item_remember,\n.item_forget {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 133px;\n    height: 25px;\n    font-size: 14px;\n    color: #7E8B9E;\n}\n\n.item_forget {\n    justify-content: flex-end;\n    color: #17a8b5;\n    cursor: pointer;\n}\n\n.submit_box {\n    width: 100%;\n    height: 43px;\n}\n\n.submit_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    border-radius: 6px;\n    cursor: pointer;\n    background-color: #abafb7;\n    color: #fff;\n    background: url('../../../../statics/login_butn.png') no-repeat center / 100% 100%;\n    transition: background-image 0.5s;\n}\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.submit_butn::after {\n    content: \"\";\n    background: url('../../../../statics/login_butn_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.submit_butn_active {\n    background: url('../../../../statics/login_butn_active.png') no-repeat center / 100% 100%;\n    transition: background 0.5s, box-shadow 0.5s;\n}\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.submit_butn_active::before {\n    content: \"\";\n    background: url('../../../../statics/login_butn_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.submit_butn_active::after {\n    content: \"\";\n    background: url('../../../../statics/login_butn_active_click.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.submit_butn_active:hover {\n    background: url('../../../../statics/login_butn_hover.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.submit_butn_active:active {\n    background: url('../../../../statics/login_butn_active_click.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.third_login {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 50px;\n}\n\n.register_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 20px;\n    margin: 15px 0;\n}\n\n.register {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    font-size: 13px;\n    color: #7e8b9e;\n}\n\n.register_link {\n    color: #3568ff;\n}\n\n.register_link:hover {\n    text-decoration: underline;\n}\n\n.right_footer {\n    position: absolute;\n    left: calc(50% - 56px);\n    bottom: 50px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 112px;\n    height: 75px;\n}\n\n.footer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n    width: 112px;\n    height: 100%;\n}\n\n.footer_img {\n    width: 48px;\n    height: 54px;\n}\n\n.footer_text {\n    font-size: 13px;\n    color: #7E8B9E;\n}\n\n.item_agree {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 25px;\n    font-size: 14px;\n    color: #7E8B9E;\n}\n\n.item_protocol {\n    color: #FF8682;\n}\n\n.code_card_main {\n    width: 100%;\n    padding-top: 200px;\n}\n\n.code_card_header {\n    position: absolute;\n    top: 16px;\n    left: 16px;\n    width: 42px;\n    height: 42px;\n    background: url('../../../../statics/code_card_go_back.png') no-repeat center / 100% 100%;\n    cursor: pointer;\n}\n\n.code_card_error_info_box {\n    padding-top: 24px;\n}\n\n.code_card_code_box {\n    margin-bottom: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PageCard_container__92Dm8`,
	"left": `PageCard_left__F+Tzy`,
	"left_header": `PageCard_left_header__RL+D0`,
	"logo": `PageCard_logo__o2nr4`,
	"logo_text": `PageCard_logo_text__sN0gk`,
	"left_middle": `PageCard_left_middle__8I0K3`,
	"welcome": `PageCard_welcome__UhtTG`,
	"explain": `PageCard_explain__mbHcE`,
	"right": `PageCard_right__IsFsH`,
	"right_header": `PageCard_right_header__9K-gm`,
	"login_text": `PageCard_login_text__TLBSW`,
	"login_explain": `PageCard_login_explain__PKaZG`,
	"form": `PageCard_form__sZ1vi`,
	"register_form": `PageCard_register_form__A7etO`,
	"error_info": `PageCard_error_info__HFXhE`,
	"register_error_info": `PageCard_register_error_info__450J+`,
	"no_error_info": `PageCard_no_error_info__KOxft`,
	"form_item": `PageCard_form_item__yt+Ca`,
	"item_title": `PageCard_item_title__6swH9`,
	"item_input": `PageCard_item_input__dKz4l`,
	"remember_forget_box": `PageCard_remember_forget_box__cYu00`,
	"protocol_box": `PageCard_protocol_box__K7+qO`,
	"item_remember": `PageCard_item_remember__6uXyM`,
	"item_forget": `PageCard_item_forget__pDOKa`,
	"submit_box": `PageCard_submit_box__GnBAt`,
	"submit_butn": `PageCard_submit_butn__mfIae`,
	"submit_butn_active": `PageCard_submit_butn_active__MzuN1`,
	"third_login": `PageCard_third_login__6Z4LT`,
	"register_box": `PageCard_register_box__vB1PO`,
	"register": `PageCard_register__7KXdT`,
	"register_link": `PageCard_register_link__fHtFB`,
	"right_footer": `PageCard_right_footer__69i8s`,
	"footer": `PageCard_footer__+gBY9`,
	"footer_img": `PageCard_footer_img__cxjBs`,
	"footer_text": `PageCard_footer_text__XBvJL`,
	"item_agree": `PageCard_item_agree__Q6r0i`,
	"item_protocol": `PageCard_item_protocol__s10is`,
	"code_card_main": `PageCard_code_card_main__KlP59`,
	"code_card_header": `PageCard_code_card_header__AQO3Q`,
	"code_card_error_info_box": `PageCard_code_card_error_info_box__JyWFm`,
	"code_card_code_box": `PageCard_code_card_code_box__kRSIR`
};
export default ___CSS_LOADER_EXPORT___;
